var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 41,
    viewBox: "0 0 19 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8186 23.5283V4.07528C12.8186 2.03071 11.1561 0.368164 9.11074 0.368164C7.0654 0.368164 5.40363 2.03071 5.40363 4.07528V23.5281C2.31566 24.9681 0.336182 28.059 0.336182 31.4825C0.336182 36.3203 4.27286 40.2557 9.11074 40.2557C13.9494 40.2557 17.8853 36.3198 17.8853 31.4825C17.8853 28.059 15.906 24.9683 12.8186 23.5283ZM17.0221 31.4819C17.0221 35.8442 13.473 39.3918 9.11074 39.3918C4.74903 39.3918 1.19942 35.8442 1.19942 31.4819C1.19942 28.31 3.08668 25.4536 6.00553 24.2056L6.26686 24.0926V4.07528C6.26686 2.50708 7.54254 1.2314 9.11074 1.2314C10.6789 1.2314 11.9546 2.50708 11.9546 4.07528V24.0932L12.2173 24.2062C15.1356 25.4536 17.0221 28.31 17.0221 31.4819Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54284 22.9801C9.54284 22.7422 9.3495 22.5488 9.11083 22.5488C8.87235 22.5488 8.67882 22.7422 8.67882 22.9801V26.6602C6.21407 26.8786 4.28186 28.9468 4.28186 31.4677C4.28186 34.1341 6.44363 36.2959 9.11083 36.2959C11.778 36.2959 13.9398 34.1341 13.9398 31.4677C13.9398 28.9468 12.0076 26.8793 9.54284 26.6602V22.9801ZM13.0766 31.4667C13.0766 33.6521 11.2976 35.4317 9.11083 35.4317C6.92407 35.4317 5.14587 33.6527 5.14587 31.4667C5.14587 29.3307 6.84929 27.5932 8.96592 27.5163C9.01242 27.533 9.05949 27.5448 9.11083 27.5448C9.16217 27.5448 9.20924 27.533 9.25574 27.5163C11.3731 27.5932 13.0766 29.3307 13.0766 31.4667Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.0945,
    y: 5.73402,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.60281
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.0945,
    y: 8.94008,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.60281
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.0945,
    y: 12.1461,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.60281
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.0945,
    y: 15.3522,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.60281
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.0945,
    y: 18.5582,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.60281
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperature);
export default __webpack_public_path__ + "static/media/iconTemperature.e697ec9a.svg";
export { ForwardRef as ReactComponent };